<template>
  <div>
    <div class="payment-calculator-container next-steps my-5 pb-4">
      <h3 class="mb-4">{{ $t('message.eCommerceV2.paymentCalculator.nextSteps') }}</h3>
      <div v-if="showFinanceCTA" class="mb-4 avr-card" data-test="financeCTA">
        <img class="d-sm-none" :src="require('@/assets/file-invoice-dollar.svg')" alt="" />
        <h3 class="mt-4 mt-sm-0">{{ $t('message.eCommerceV2.cards.finance.heading') }}</h3>
        <div class="row">
          <div class="col">
            <p class="text-dark mb-sm-1 mr-0 mr-sm-2">{{ $t('message.eCommerceV2.cards.finance.copy') }}</p>
          </div>
          <div class="col-sm-auto">
            <mobialis-button
              class="mt-3 mt-sm-2"
              :width="'w-auto'"
              :size="'btn-md'"
              @click="$router.push('finance/finance-intro')"
              data-cy="footerApplyFinancing"
              v-av-analytics-cta-interaction="{
                elementText: $t('message.eCommerceV2.cards.finance.btn'),
                eventActionResult: 'open',
              }"
              >{{ $t('message.eCommerceV2.cards.finance.btn') }}</mobialis-button
            >
          </div>
        </div>
      </div>
      <div v-if="showOfferCTA" class="mb-4 avr-card" data-test="offerCTA">
        <img class="d-sm-none" :src="require('@/assets/envelope-open-dollar.svg')" alt="" />
        <h3 class="mt-4 mt-sm-0">{{ $t('message.eCommerceV2.cards.offer.heading') }}</h3>
        <div class="row">
          <div class="col">
            <p class="text-dark mb-sm-1 mr-0 mr-sm-2">{{ $t('message.eCommerceV2.cards.offer.copy') }}</p>
          </div>
          <div class="col-sm-auto">
            <mobialis-button
              class="mt-3 mt-sm-2"
              :width="'w-auto'"
              :size="'btn-md'"
              @click="$router.push('offer/offer-summary-form')"
              data-cy="makeOffer"
              v-av-analytics-cta-interaction="{
                elementText: $t('message.eCommerceV2.cards.offer.btn'),
                eventActionResult: 'open',
              }"
              >{{ $t('message.eCommerceV2.cards.offer.btn') }}</mobialis-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { AVRProducts, PaymentMethod } from '@/utils/enums';

export default {
  name: 'PaymentCalculatorCTAs',
  data() {
    return {};
  },
  computed: {
    ...mapState('paymentCalculator', ['paymentMethod']),
    ...mapGetters(['getCurrentProduct']),
    isEcomV2() {
      return this.getCurrentProduct === AVRProducts.ECOMV2;
    },
    showFinanceCTA() {
      return this.paymentMethod !== PaymentMethod.CASH || !this.isEcomV2;
    },
    showOfferCTA() {
      return this.isEcomV2;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-calculator-container {
  max-width: 650px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
}

.fr-CA {
  .payment-calculator-container {
    max-width: 750px;
  }
}
</style>
